// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GlobeHemisphereEastBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 2.5A13.5 13.5 0 1 0 29.5 16 13.515 13.515 0 0 0 16 2.5Zm0 3a10.446 10.446 0 0 1 5.5 1.56v2L18.974 12l-3.559.481-2.337-1.531a2.499 2.499 0 0 0-3.51.66l-2.617 3.913c-.273.406-.42.884-.422 1.375l-.02 3.586A10.5 10.5 0 0 1 16 5.5ZM8.551 23.392a2.5 2.5 0 0 0 .949-1.948l.025-4.375 2.259-3.375 2.077 1.36a2.49 2.49 0 0 0 1.768.427l3.934-.532a2.5 2.5 0 0 0 1.562-.85l2.77-3.224a2.52 2.52 0 0 0 .549-1.113 10.474 10.474 0 0 1 1.765 8.686L24.79 17.15a2.51 2.51 0 0 0-2.646-.463l-3.806 1.582a2.512 2.512 0 0 0-1.514 1.944l-.299 2.025a2.5 2.5 0 0 0 1.839 2.782l2 .523a10.473 10.473 0 0 1-11.809-2.155l-.005.003Zm14.597.29-.204-.203a2.505 2.505 0 0 0-1.135-.653l-2.25-.59.191-1.301L23 19.584l2 1.823c-.51.841-1.133 1.607-1.852 2.276Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
